import { render, staticRenderFns } from "./CostExpenses.vue?vue&type=template&id=74007d5c&scoped=true"
import script from "./CostExpenses.vue?vue&type=script&lang=js"
export * from "./CostExpenses.vue?vue&type=script&lang=js"
import style0 from "./CostExpenses.vue?vue&type=style&index=0&id=74007d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74007d5c",
  null
  
)

export default component.exports